import FareRuleList from './FareRuleList';

export default FareRuleList;
